import React, { useCallback, useEffect, useState } from "react";
import HeartCxContext from "src/contexts/HeartCxContext";

type PropTypes = {
    children?: React.ReactNode;
};

const hearts = new Set<string>();
const unhearts = new Set<string>();
const heartedAsins = new Set<string>();

const isHearted = (asin: string, isMetadataHearted: boolean): boolean => {
    return (isMetadataHearted && !unhearts.has(asin)) || hearts.has(asin);
};

const HeartCxManager: React.FC<PropTypes> = ({ children }) => {
    const [lastUpdateTimestamp, setLastUpdateTimestamp] = useState(Date.now());

    useEffect(() => {
        return () => {
            hearts.clear();
            unhearts.clear();
            heartedAsins.clear();
        };
    }, []);

    const heartAsin = useCallback((asin: string) => {
        hearts.add(asin);
        unhearts.delete(asin);
        setLastUpdateTimestamp(Date.now());
    }, []);

    const unheartAsin = useCallback((asin: string) => {
        hearts.delete(asin);
        unhearts.add(asin);
        setLastUpdateTimestamp(Date.now());
    }, []);

    return (
        <HeartCxContext.Provider
            value={{
                isHearted,
                heartAsin,
                unheartAsin,
                lastUpdateTimestamp: lastUpdateTimestamp,
            }}
        >
            {children}
        </HeartCxContext.Provider>
    );
};

export default HeartCxManager;
